/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { BookingEngagement } from "./BookingEngagement";
import {
  BookingEngagementFromJSON,
  BookingEngagementFromJSONTyped,
  BookingEngagementToJSON,
  BookingEngagementToJSONTyped,
} from "./BookingEngagement";

/**
 *
 * @export
 * @interface SetBookingEngagementOverrideRequest
 */
export interface SetBookingEngagementOverrideRequest {
  /**
   *
   * @type {string}
   * @memberof SetBookingEngagementOverrideRequest
   */
  companyId: string;
  /**
   *
   * @type {BookingEngagement}
   * @memberof SetBookingEngagementOverrideRequest
   */
  value: BookingEngagement;
  /**
   *
   * @type {LocalDate}
   * @memberof SetBookingEngagementOverrideRequest
   */
  until: LocalDate;
  /**
   *
   * @type {string}
   * @memberof SetBookingEngagementOverrideRequest
   */
  reason: string;
}

/**
 * Check if a given object implements the SetBookingEngagementOverrideRequest interface.
 */
export function instanceOfSetBookingEngagementOverrideRequest(
  value: object,
): value is SetBookingEngagementOverrideRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("until" in value) || value["until"] === undefined) return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  return true;
}

export function SetBookingEngagementOverrideRequestFromJSON(
  json: any,
): SetBookingEngagementOverrideRequest {
  return SetBookingEngagementOverrideRequestFromJSONTyped(json, false);
}

export function SetBookingEngagementOverrideRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetBookingEngagementOverrideRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    value: BookingEngagementFromJSON(json["value"]),
    until: json["until"],
    reason: json["reason"],
  };
}

export function SetBookingEngagementOverrideRequestToJSON(
  json: any,
): SetBookingEngagementOverrideRequest {
  return SetBookingEngagementOverrideRequestToJSONTyped(json, false);
}

export function SetBookingEngagementOverrideRequestToJSONTyped(
  value?: SetBookingEngagementOverrideRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    value: BookingEngagementToJSON(value["value"]),
    until: value["until"],
    reason: value["reason"],
  };
}
